import { connect } from "react-redux";

import { getftpPublishedClips } from "../../store/videogrid/duck";
import FTPcomponent from "./component";

const FTPContainer = connect(() => ({}), {
  getftpPublishedClips,
})(FTPcomponent);

export default FTPContainer;
